<template>
    <div class="focus-lock" ref="focusEl">
        <!-- Sentinels exist only while the trap is on. They used to render
             all the time with tabindex="1", and a positive tabindex jumps the
             queue: every page started with two empty tab stops ahead of the
             skip link. -->
        <div v-if="enabled" tabindex="0" data-focus-sentinel @focus="focusOut('start')"></div>
        <slot></slot>
        <div v-if="enabled" tabindex="0" data-focus-sentinel @focus="focusOut('end')"></div>
    </div>
</template>

<script setup>
    const props = defineProps({
        enabled: {
            type: Boolean,
            default: false,
        },
    });

    const { enabled } = toRefs(props);
    const focusEl = ref(null);

    const TABBABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    // Focus reached a sentinel, so it is leaving the trapped content: wrap it
    // round to the other end. Only rendered controls count — the drawer's
    // collapsed sub-menus are still in the DOM.
    const focusOut = (fromDirection) => {
        if (!enabled.value || !focusEl.value) return;

        const focusable = Array.from(focusEl.value.querySelectorAll(TABBABLE)).filter(
            (el) => !el.hasAttribute('data-focus-sentinel') && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'
        );
        if (!focusable.length) return;

        const target = fromDirection === 'start' ? focusable[focusable.length - 1] : focusable[0];
        target.focus();
    };
</script>
